<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-con">
            <ul class="company-list">
              <li class="company">
                <img src="@/assets/static/images/whb_thumb.png" alt="sample">
                <div @click="outLink(`https://whb.or.kr/`)" >월드휴먼브리지</div>
              </li>
              <li class="company">
                <img src="@/assets/static/images/hi-family01.jpg" alt="sample" />
                <div @click="outLink(`http://www.hifamily.org/`)">
                  하이패밀리
                </div>
                <!--                <a href="http://hifamily.org/skin/page/funeral01.html" target="_blank">하이패밀리</a>-->
              </li>

              <!--<li class="company">-->
              <!--  <img src="@/assets/static/images/sample/img-area.png" alt="sample" />-->
              <!--  <div @click="outLink(`http://hifamily.org/skin/page/funeral01.html`)">기업명 클릭 링크 이동</div>-->
              <!--</li>-->
            </ul>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn primary medium" @click="close">닫기</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { nativeLink } from '@/common/utils/module/NativeRequest';

const emits = defineEmits(['close']);
const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};

const outLink = url => {
  nativeLink(url);
};
</script>

<style scoped>
.company {
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }

  div {
    margin-top: 1rem;
    display: inline-block;
    color: #006ae6;
    font-size: 1.5rem;
    text-align: center;
    text-decoration: underline;
    width: 100%;
  }
}
</style>
